import {
	LocalizationService,
	type SupportedLanguage
} from '@newo/localization';
import { useCallback, useMemo } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Route, Routes } from 'react-router-dom';
// components
import Layout from '@/srcV2/components/Layout';
import { PATHS } from '@/srcV2/constants';
import { HostContextProvider } from '@/srcV2/context/HostContext.tsx';
import { useLocalization } from '@/srcV2/hooks/useLocalization.ts';
import CreatorIntro from '@/srcV2/pages/CreatorIntro';

const App = () => {
	const localization = useLocalization();

	const onChangeLanguage = useCallback((value: string | null) => {
		if (!value) {
			return;
		}

		LocalizationService.setLanguage(value as SupportedLanguage);
	}, []);

	const providedLocalization = useMemo(() => {
		return {
			...localization,
			onChangeLanguage
		};
	}, [localization, onChangeLanguage]);

	return (
		<HostContextProvider
			value={{
				localization: providedLocalization
			}}
		>
			<HelmetProvider>
				<Routes>
					<Route
						element={<Layout />}
						path={PATHS.creatorIndex}
					>
						<Route
							element={<CreatorIntro />}
							index
						/>
					</Route>
				</Routes>
			</HelmetProvider>
		</HostContextProvider>
	);
};

export default App;
